import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "error" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = { class: "modal-footer justify-content-between" }
const _hoisted_15 = { class: "dropdown dropup" }
const _hoisted_16 = {
  key: 0,
  type: "button",
  class: "btn btn-danger",
  "data-toggle": "dropdown"
}

import { ref, computed, watch, toRef } from 'vue'

    import { EditorState } from '@common/Common'
    import type { SurveyEditorDialogViewModel } from '@Evaluation/CriteriaSurveys/Components/SurveyEditorDialog'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'SurveyEditorDialog',
  props: {
    viewModel: {}
  },
  emits: ["create-survey", "update-survey", "delete-survey"],
  setup(__props: any, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- shortcuts ----------------

    const vm = toRef(props, 'viewModel')

    // ---------------- derived (VM passthrough) ----------------

    const opened = computed(() => vm.value?.opened ?? false)
    const state = computed(() => vm.value.editorState)
    const title = computed(() => vm.value.editorTitle)
    const nameError = computed(() => vm.value.nameError)

    // writable computed (mirrors getter/setter)
    const responseDueDate = computed<string | null>({
        get: () => vm.value.responseDueDate,
        set: val => { vm.value.responseDueDate = val }
    })

    // ---------------- local form state ----------------

    const Initialized = ref(false)

    const SurveyId = ref<number | null>(null)
    const Name = ref<string | null>(null)
    const Description = ref<string | null>(null)

    // ---------------- watch ----------------

    watch(state, (val, oldVal) =>
    {
        if (val === EditorState.Closed)
        {
            Initialized.value = false
        }
        else
        {
            vm.value.clearValidationErrors()

            SurveyId.value = vm.value.surveyId
            Name.value = vm.value.surveyName
            Description.value = vm.value.surveyDescription

            Initialized.value = true
        }
    })

    // ---------------- actions ----------------

    function CreateCommand()
    {
        vm.value.clearValidationErrors()
        emit(
            'create-survey',
            SurveyId.value,
            Name.value,
            Description.value,
            responseDueDate.value
        )
    }

    function UpdateCommand()
    {
        vm.value.clearValidationErrors()
        emit(
            'update-survey',
            SurveyId.value,
            Name.value,
            Description.value,
            responseDueDate.value
        )
    }

    function DeleteCommand()
    {
        emit('delete-survey', SurveyId.value)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (state.value !== 'Closed')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("h5", _hoisted_6, _toDisplayString(title.value), 1 /* TEXT */),
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "close"
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_7, [
                (Initialized.value === false)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_8, [...(_cache[3] || (_cache[3] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading... ", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (Initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _cache[4] || (_cache[4] = _createElementVNode("label", null, "Name", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((Name).value = $event)),
                          class: "form-control"
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            Name.value,
                            void 0,
                            { trim: true }
                          ]
                        ]),
                        _createElementVNode("div", _hoisted_11, _toDisplayString(nameError.value), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        _cache[5] || (_cache[5] = _createElementVNode("label", null, "Description", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("textarea", {
                          type: "text",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((Description).value = $event)),
                          class: "form-control"
                        }, null, 512 /* NEED_PATCH */), [
                          [
                            _vModelText,
                            Description.value,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        _cache[6] || (_cache[6] = _createElementVNode("label", null, "Response due date:", -1 /* CACHED */)),
                        _withDirectives(_createElementVNode("input", {
                          type: "date",
                          class: "form-control",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((responseDueDate).value = $event))
                        }, null, 512 /* NEED_PATCH */), [
                          [_vModelText, responseDueDate.value]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (state.value === 'Editor')
                    ? (_openBlock(), _createElementBlock("button", _hoisted_16, "Delete"))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", {
                    class: "dropdown-menu",
                    role: "menu",
                    style: {"padding":"10px"}
                  }, [
                    _cache[7] || (_cache[7] = _createElementVNode("a", { class: "dropdown-item" }, "Cancel", -1 /* CACHED */)),
                    _createElementVNode("a", {
                      class: "dropdown-item",
                      onClick: DeleteCommand
                    }, "Confirm")
                  ])
                ]),
                _createElementVNode("div", null, [
                  (state.value === 'Creator')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: CreateCommand,
                        type: "button",
                        class: "btn btn-primary"
                      }, "Create"))
                    : _createCommentVNode("v-if", true),
                  (state.value === 'Editor')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: UpdateCommand,
                        type: "button",
                        class: "btn btn-primary"
                      }, "Save"))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("button", {
                    onClick: close,
                    type: "button",
                    class: "btn btn-outline-secondary"
                  }, "Cancel")
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})